module.exports = __webpack_public_path__ + "static/panecolor-d4f6428853181cfd8fdd55ab3e435b4e.png";